import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/xponentialPlusSagas";
import { useDispatch, useSelector } from "react-redux";
import NumberDisplay from "../../../components/moneyDisplay/moneyDisplay";
import PercentageDisplay from "../../../components/percentageDisplay/percentageDisplay";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";
import LearnMore from "../../../components/learnMore/learnMore";
import { useDateFormat } from "../../../hooks/useDateFormat";
import { isEmpty } from "lodash";

const IntroBreakdownModule = (props) => {
  const dateFormat = useDateFormat();

  const {
    isUpdating,
    isLoading,
    currentUser: { calendarEndDate, calendarStartDate },
    date,
    dataPoints: { trials, newMembers, activePaying, recurringRevenue }
  } = useSelector((state) => state.xponentialPlus);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const updateDates = (date) => dispatch(actionCreators.updateData(date));

  const content = () => {
    return (
      <div id="xponentialPlus">
        <div className="edit-selections-bar">
          <div className="date-select-box">
            <p className="offers-title">Date</p>
            <ReactDatePicker
              displayFormat={dateFormat}
              startDate={date}
              calendarEndDate={calendarEndDate}
              minDate={calendarStartDate}
              updateDates={updateDates}
            />
          </div>
        </div>

        {!isUpdating ? (
          <>
            <div className="data-points">
              {!isEmpty(trials) && (
                <div className="data-points__elem">
                  <SectionContainer title={trials.title}>
                    <NumberDisplay value={trials.value} url={trials.url} />
                  </SectionContainer>
                </div>
              )}
              {!isEmpty(newMembers) && (
                <div className="data-points__elem">
                  <SectionContainer title={newMembers.title}>
                    <PercentageDisplay
                      value={newMembers.value}
                      url={newMembers.url}
                      showDecimal
                      toFixedValue={1}
                      toolTipContent={newMembers.tooltip}
                      tooltipId="newMemberSubscriptionToolTip"
                    />
                  </SectionContainer>
                </div>
              )}
              {!isEmpty(activePaying) && (
                <div className="data-points__elem">
                  <SectionContainer title={activePaying.title}>
                    <NumberDisplay value={activePaying.value} url={activePaying.url} />
                  </SectionContainer>
                </div>
              )}
              {!isEmpty(recurringRevenue) && (
                <div className="data-points__elem">
                  <SectionContainer title={recurringRevenue.title}>
                    <NumberDisplay
                      value={recurringRevenue.value}
                      url={recurringRevenue.url}
                      currency="$"
                    />
                  </SectionContainer>
                </div>
              )}
            </div>
          </>
        ) : (
          <LoadingAnimation text="Updating data..." />
        )}
      </div>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      title="Xponential+"
      content={content()}
      learnMore={<LearnMore title={props.learnMore.title} content={props.learnMore.content} html />}
    />
  );
};

IntroBreakdownModule.propTypes = { params: PropTypes.object };

export default IntroBreakdownModule;
